import OptionsModel from 'mobx-react-form/lib/models/OptionsModel';

export const formOptions: OptionsModel = {
  validationDebounceWait: 0,
  validateOnChange: true,
  validateOnReset: true,
  showErrorsOnReset: false,
};
